import { Alert, CircularProgress, Fade, Icon, IconButton, InputAdornment } from "@mui/material";
import lod_ from "lodash";
import MDBox from "components/Basics/MDBox";
import MDInput from "components/Basics/MDInput";
import MDTypography from "components/Basics/MDTypography";
import { t } from "i18next";
import { useState } from "react";
import SourceActions from "redux-react/actions/sourceActions";
import { useDispatch } from "react-redux";
import { checkIfSourcesExist } from "hooks/sources";

/**
 * Component to import a sitemap
 * @param {*} param0
 * @returns {JSX.Element} - SiteMapImport
 */
const SiteMapImport = ({ onFilesSelection, validStep }) => {
	const dispatch = useDispatch();

	const [loadingProgress, setLoadingProgress] = useState(false);

	const [url, setUrl] = useState("");
	const [urlError, setUrlError] = useState(null);

	/**
	 * Download sitemap from URL
	 */
	const downloadFileFromUrl = async () => {
		setUrlError(null);
		setLoadingProgress(true);

		dispatch(
			SourceActions.getIntegrationSitemap(
				url,
				async res => {
					try {
						const filesResult = await checkIfSourcesExist(dispatch, res);
						onFilesSelection(filesResult);
						validStep();
						setLoadingProgress(false);
					} catch {
						setLoadingProgress(false);
						setUrlError(t("SOURCES.UPLOAD.urlError"));
					}
				},
				err => {
					setLoadingProgress(false);
					setUrlError(t("SOURCES.UPLOAD.urlError"));
				}
			)
		);
	};

	return (
		<MDBox mt={5} display="flex" flex="1" flexDirection="row" justifyContent="center">
			<MDBox sx={{ width: "70%" }}>
				<MDTypography variant="h4">{t("SOURCES.SITEMAP.title")}</MDTypography>
				<MDTypography variant="subtitle2">{t("SOURCES.SITEMAP.subtitle")}</MDTypography>
				<MDInput
					autoFocus
					sx={{ mt: 5 }}
					disabled={loadingProgress}
					value={url}
					className="dialogInput"
					placeholder={t("SOURCES.UPLOAD.urlPlaceholder")}
					onChange={e => {
						setUrlError("");
						setUrl(e.target.value);
					}}
					onKeyDown={e => {
						if (e.key === "Enter") {
							downloadFileFromUrl();
						}
					}}
					InputProps={{
						endAdornment: (
							<InputAdornment position="end">
								{!loadingProgress && (
									<IconButton disabled={Boolean(!url)} color="info" onClick={downloadFileFromUrl}>
										<Icon>search</Icon>
									</IconButton>
								)}
								{loadingProgress && <CircularProgress color="info" size={20} />}
							</InputAdornment>
						)
					}}
				/>
				{/* Loading */}
				{loadingProgress && (
					<Fade in={loadingProgress} timeout={300}>
						<MDBox sx={{ mt: 3 }}>
							<Alert
								icon={
									<CircularProgress size={25} sx={{ marginRight: 2 }} thickness={5} color="info" />
								}
								severity="info"
							>
								<MDTypography variant="h6" fontSize="small" color="info">
									{t("SOURCES.SITEMAP.loadingSitemap")}
								</MDTypography>
							</Alert>
						</MDBox>
					</Fade>
				)}
				{/* Error */}
				{urlError && (
					<Fade in={!lod_.isNil(urlError) && !lod_.isEmpty(urlError)} timeout={300}>
						<MDBox sx={{ mt: 3 }}>
							<Alert icon={<Icon color="error">close</Icon>} severity="error">
								<MDTypography variant="h6" fontSize="small" color="error">
									{urlError}
								</MDTypography>
							</Alert>
						</MDBox>
					</Fade>
				)}
			</MDBox>
		</MDBox>
	);
};

export default SiteMapImport;
